// extracted by mini-css-extract-plugin
export default {"service":"forth_service__KzZW-","one":"forth_one__+mS6w","two":"forth_two__rq9NT","section":"forth_section__dvf6w"};